<template>
  <label :id="`${props.for}-label`" :for="props.for" :class="theme.text" class="modern-color-theme font-poppins leading-6 flex items-center" data-component-name="VSLabel">
    <slot />
    <VIcon v-if="props.icon" color="neutral" size="xs" :name="props.icon" class="ml-1 cursor-pointer" />
    <VTooltip v-if="props.tooltip" :content="props.tooltip" :position="props.tooltipPosition">
      <VIcon color="neutral" size="xs" name="Outline/information-circle" class="ml-1 cursor-pointer" />
    </VTooltip>
  </label>
</template>
<script setup lang="ts">
import VTooltip from '@library/dialogs/VTooltip.vue'
import VIcon from '@library/labels/VIcon.vue'
import { useTheme } from '@library/themes/themes'
import type { ThemeProp } from '@library/themes/types'
import type { Position } from '@utils/position'
import type { Icon } from '@icons/index'

const props = defineProps<{
  for: string
  tooltip?: string
  tooltipPosition?: Position.Snap
  theme?: ThemeProp<'VSLabel'>
  icon?: Icon
}>()

const theme = useTheme(props, 'VSLabel')

defineOptions({
  name: 'VSLabel'
})
</script>